/* LinksComponent.js */

"use strict";
const _ = require("lodash");
const QueryView = require("../../subviews/query_view/QueryViewComponent");
const childViewComponent = require("../../../../../../widgets/childview/ChildViewRenderer");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./LinksRenderer");
class LinksComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._value = value;
        this._adhocDetails = context.adhocDetails;

        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        if (this._value) {
            // this._value.on(
            //     "PropertiesUpdated",
            //     (this.updateComponent = this.updateComponent.bind(this))
            // );
        }
    }

    _unregisterListeners() {
        if (this._value && this._value.removeListener) {
            // this._value.removeListener("PropertiesUpdated", this.updateComponent);
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        this._adhocDetails = undefined;
        return prom;
    }

    /******************************************/
    /* START PUBLIC API METHODS               */
    /******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setLinks(newVal);
        }
    }

    getValue() {
        return this.getLinks();
    }

    updateComponent(after, before) {
        if (after && before) {
            this.emit("LinksAdhoc", before);
        }
    }

    setLinks(newVal) {
        this._value = newVal;
    }

    getLinks() {
        return this._value;
    }

    /******************************************/
    /* END PUBLIC API METHODS                 */
    /******************************************/
    viewConfiguration() {
        // if(_.isEmpty(this._adhocDetails._matchCount)) {
        //     return;
        // }

        const selectedResultEntity = this._value,
            pristineValues = this._adhocDetails._proxyAdHocQueryEntity.getPristineProperties(),
            deviceResultMap = {};
        let deviceList = [];

        deviceList = Object.values(this._adhocDetails._adHocQueryResultEntitiesGen._feed.getCache()).map((result) => {
            Object.assign(deviceResultMap, { [result.getDeviceId()]: result });
            return result.getDeviceId();
        });
        deviceList = this._adhocDetails.getDeviceOptionsForQueryView(deviceList);

        let device = selectedResultEntity.getDeviceId();
        // const savedQuery = this._adhocDetails.renderer.selectedSavedQuery;
        const searchField = pristineValues.query,
            searchType = pristineValues.source || "LATEST",
            searchMethod = pristineValues.filter || "NONE",
            conceptItem = pristineValues.conceptItemId || "",
            showCommand = pristineValues.showCommands || "";
        this._queryViewComponent = new QueryView({
            device: device,
            deviceList,
            deviceResultMap,
            query: searchField,
            searchType: searchType,
            matches: this._adhocDetails._matchCount,
            parentRenderer: this._adhocDetails.renderer,
            jobEntityDef: this._adhocDetails._jobEntityDef,
            selectedResultEntity,
            searchMethod,
            conceptItem,
            showCommand
        });

        this._queryViewComponent.renderer.render().then(() => {
            this._childViewRenderer = new childViewComponent({
                data: this._queryViewComponent.renderer.rootElement,
                backLink: "Ad Hoc Query",
                title: "Query Results",
                childData: this._queryViewComponent,
                parentData: this._adhocDetails,
                backButton: true
            });
            this.emit("QueryViewOpen");
        });
    }

    isEnabled() {
        if (_.get(this._adhocDetails, "_adHocRun", false) || _.get(this._adhocDetails, "_lastRunSelected", false)) {
            const currentResultEntity = this._value;

            if (
                !_.isEmpty(currentResultEntity) &&
                currentResultEntity.getStatus() === "COMPLETE" &&
                _.isUndefined(currentResultEntity.getErrorMsg())
            ) {
                return true;
            } else {
                return false;
            }
        }
        return false;
    }
}

module.exports = LinksComponent;
